import { useEffect } from 'react';
import { useCoreLoopConfigurationStore } from '@core/coreLoopConfiguration/useCoreLoopConfigurationStore';
import usePortalAccess from '@/access/usePortalAccess';
import { useTenantId } from '@/contexts/TenantContext';

const useCustomAssignmentRatesAccess = (jobTenantId?: string | null) => {
  const currentTenantId = useTenantId();
  const tenantId = jobTenantId ?? currentTenantId;

  const ensureCoreLoopConfiguration = useCoreLoopConfigurationStore(
    (state) => state.ensureCoreLoopConfiguration,
  );
  const isConfigurationLoadedForTenant = useCoreLoopConfigurationStore(
    (state) =>
      !!tenantId &&
      state.loadedTenantId === tenantId &&
      state.coreLoopConfigurationStatus === 'ready',
  );
  const enableCustomAssignmentRates = useCoreLoopConfigurationStore(
    (state) =>
      state.coreLoopConfigurationItems?.enableCustomAssignmentRates === true,
  );
  const { isClientPortal, canManageTenantJobs } = usePortalAccess();

  useEffect(() => {
    if (tenantId) {
      void ensureCoreLoopConfiguration(tenantId);
    }
  }, [ensureCoreLoopConfiguration, tenantId]);

  return (
    isConfigurationLoadedForTenant &&
    enableCustomAssignmentRates &&
    !isClientPortal &&
    canManageTenantJobs
  );
};

export default useCustomAssignmentRatesAccess;
